// react
import { m } from 'framer-motion';
// @mui
import { Box, Container, Typography } from '@mui/material';
// components
import Page from './Page';
import Iconify from './Iconify';
import { MotionContainer, varBounce } from './animate';
// sections
import InlinePerkUpsell from '../sections/@dashboard/e-commerce/membership/InlinePerkUpsell';

// ----------------------------------------------------------------------

export default function BlockPerk({ perk }) {
    return (
        <Page title="Herramienta no habilitada">
            <Container maxWidth="lg" component={MotionContainer} sx={{ py: { xs: 4, md: 6 } }}>
                <Box sx={{ textAlign: 'center', mb: 5 }}>
                    <m.div variants={varBounce().in}>
                        <Iconify icon="tabler:face-id-error" width={72} height={72} sx={{ color: 'text.disabled' }} />
                    </m.div>
                    <m.div variants={varBounce().in}>
                        <Typography variant="h3" sx={{ mt: 2 }}>
                            Aún no tienes acceso a esta herramienta
                        </Typography>
                    </m.div>
                    <m.div variants={varBounce().in}>
                        <Typography sx={{ color: 'text.secondary', mt: 1.5, maxWidth: 520, mx: 'auto' }}>
                            Puedes desbloquearla con un pago único o con tu suscripción. Elige tu plan aquí mismo — no tienes que salir de esta pantalla.
                        </Typography>
                    </m.div>
                </Box>

                {perk ? (
                    <InlinePerkUpsell perk={perk} />
                ) : (
                    <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>
                        No pudimos identificar el producto correspondiente.
                    </Typography>
                )}
            </Container>
        </Page>
    );
}
